import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import {store} from './store';
import routes from './routes';
import * as serviceWorker from './serviceWorker';
import App from './components/App';
import I18nProvider from './containers/I18nProvider';

// Global Styles:
import './styles/global-styles.scss';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
const { pathname } = window.location;

const clientPath = `/lang${pathname}`;
const supportedLanguages = [
  'en',
  'es',
  'es-419',
  'pt-BR'
];
const languageMap = {
  BR: 'pt-BR',
  PT: 'pt-BR',
  CO: 'es',
  PE: 'es',
  AR: 'es-419',
  UY: 'es-419',
  EC: 'es'
}
root.render(
  <Provider store={store}>
    <BrowserRouter>
    <I18nProvider
    supportedLanguages={supportedLanguages}
    clientPath={clientPath}
    parameters={window.location.search}
    languageMap={languageMap}
  >
    <App routes={routes} />
  </I18nProvider>
    </BrowserRouter>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
